// (function () {
//   'use strict';

//   // ─── CONFIG ──────────────────────────────────────────────────────────────────
//   var DELAY_SRCS  = ['shopifycloud','trekkie.storefront','facebook'];
//   var DELAY_FONTS = ['gtstandard', 'gravity-font-faces', 'shoplift'];
//   var FALLBACK_MS = 2000;
//   var STATIC_SEL  = 'script[type="text/djava"][data-src]';

//   // ─── STATE ───────────────────────────────────────────────────────────────────
//   var released = false;
//   var seen     = Object.create(null);
//   var queue    = { static: [], dynamic: [] };
//   var mo;

//   // ─── UTILS ───────────────────────────────────────────────────────────────────
//   function lc(v) { return v == null ? '' : String(v).toLowerCase(); }
//   function matches(s, arr) { s = lc(s); return arr.some(function(k){ return s.indexOf(k) !== -1; }); }
//   function isModule(src)   { return lc(src).indexOf('portable-wallets/latest/portable-wallets') !== -1; }
//   function idle(fn)        { (window.requestIdleCallback || setTimeout)(fn, window.requestIdleCallback ? { timeout: 2000 } : 1); }

//   function getAttrs(node) {
//     var out = [];
//     for (var i = 0; node && node.attributes && i < node.attributes.length; i++)
//       out.push([node.attributes[i].name, node.attributes[i].value]);
//     return out;
//   }

//   // ─── FONT BLOCKING ───────────────────────────────────────────────────────────
//   function isFontNode(el) {
//     if (!el || el.nodeType !== 1) return false;
//     var tag  = el.tagName;
//     var href = lc(el.getAttribute && el.getAttribute('href') || '');
//     var body = lc(el.textContent || el.outerHTML || '');
//     return (tag === 'STYLE' || tag === 'LINK') && matches(href || body, DELAY_FONTS);
//   }

//   function purgeFonts(root) {
//     var nodes = (root || document).querySelectorAll('style,link');
//     for (var i = 0; i < nodes.length; i++)
//       if (isFontNode(nodes[i]) && nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
//     if (isFontNode(root) && root.parentNode) root.parentNode.removeChild(root);
//   }

//   // ─── QUEUE HELPERS ───────────────────────────────────────────────────────────
//   function enqueue(type, item, key) {
//     if (seen[key]) return;
//     seen[key] = 1;
//     queue[type].push(item);
//   }

//   function collectStatic(root) {
//     var nodes = (root || document).querySelectorAll(STATIC_SEL);
//     for (var i = 0; i < nodes.length; i++) {
//       var n = nodes[i], src = n.getAttribute('data-src');
//       if (!src) continue;
//       enqueue('static', { src: src, attrs: getAttrs(n) }, 's|' + src);
//       if (n.parentNode) n.parentNode.removeChild(n);
//     }
//   }

//   function enqueueScript(node, src) {
//     enqueue('dynamic', {
//       src:   src || '',
//       type:  lc(node.type || ''),
//       text:  node.textContent || '',
//       attrs: getAttrs(node)
//     }, 'd|' + src + '|' + lc(node.type || '') + '|' + (node.textContent || '').slice(0, 80));
//   }

//   // ─── SCRIPT RESTORE ──────────────────────────────────────────────────────────
//   function restore(item, done) {
//     var s = document.createElement('script');
//     item.attrs.forEach(function(a) {
//       var k = lc(a[0]);
//       if (k === 'src' || k === 'type' || k === 'data-src') return;
//       try { s.setAttribute(a[0], a[1]); } catch(e) {}
//     });
//     if (item.type === 'module' || isModule(item.src)) s.type = 'module';
//     s.async = true;
//     if (item.src) {
//       s.onload = s.onerror = function() { done && done(); };
//       s.src = item.src;
//     } else {
//       s.text = item.text;
//     }
//     document.head.appendChild(s);
//     if (!item.src) done && done();
//   }

//   function replay(list, i) {
//     if (i >= list.length) return;
//     restore(list[i], function() { idle(function() { replay(list, i + 1); }); });
//   }

//   // ─── RELEASE ─────────────────────────────────────────────────────────────────
//   function release() {
//     if (released) return;
//     released = true;
//     unbind();
//     if (mo) try { mo.disconnect(); } catch(e) {}
//     idle(function() {
//       replay(queue.static, 0);
//       // slight gap so static scripts don't compete with dynamic ones for main thread
//       idle(function() { replay(queue.dynamic, 0); });
//     });
//   }

//   // ─── INTERACTION TRIGGERS ────────────────────────────────────────────────────
//   var EVENTS = ['pointerdown', 'keydown', 'touchstart', 'scroll', 'mousemove', 'click'];

//   function bind()   { EVENTS.forEach(function(e){ window.addEventListener(e, release, { passive: true, once: true }); }); }
//   function unbind() { EVENTS.forEach(function(e){ window.removeEventListener(e, release); }); }

//   // ─── INTERCEPT appendChild / insertBefore ────────────────────────────────────
//   function intercept(orig) {
//     return function(child, ref) {
//       if (!released && child && child.tagName === 'SCRIPT') {
//         var src = child.src || (child.getAttribute && child.getAttribute('src')) || '';
//         if (matches(src, DELAY_SRCS)) {
//           enqueueScript(child, src);
//           return orig.call(this, document.createComment('⏸ delayed:' + src.split('/').pop()), ref || null);
//         }
//       }
//       return orig.call(this, child, ref || null);
//     };
//   }
//   Node.prototype.appendChild  = intercept(Node.prototype.appendChild);
//   Node.prototype.insertBefore = intercept(Node.prototype.insertBefore);

//   // intercept setAttribute (e.g. script.src = ...)
//   var _setAttr = Element.prototype.setAttribute;
//   Element.prototype.setAttribute = function(name, value) {
//     if (!released && this.tagName === 'SCRIPT' && lc(name) === 'src' && matches(value, DELAY_SRCS)) {
//       enqueueScript(this, value);
//       return _setAttr.call(this, name, '');
//     }
//     return _setAttr.call(this, name, value);
//   };

//   // intercept src property setter
//   try {
//     var sd = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src');
//     if (sd && sd.set) {
//       Object.defineProperty(HTMLScriptElement.prototype, 'src', {
//         get: sd.get,
//         set: function(v) {
//           if (!released && matches(v, DELAY_SRCS)) { enqueueScript(this, v); return sd.set.call(this, ''); }
//           return sd.set.call(this, v);
//         }
//       });
//     }
//   } catch(e) {}

//   // ─── MUTATION OBSERVER ───────────────────────────────────────────────────────
//   try {
//     mo = new MutationObserver(function(mutations) {
//       if (released) return;
//       mutations.forEach(function(m) {
//         m.addedNodes.forEach(function(n) {
//           if (!n || n.nodeType !== 1) return;
//           purgeFonts(n);
//           if (n.tagName !== 'SCRIPT') { collectStatic(n); return; }

//           var src  = n.getAttribute('data-src') || n.src || n.getAttribute('src') || '';
//           var type = lc(n.type || '');

//           if (type === 'text/djava' && n.getAttribute('data-src')) {
//             enqueue('static', { src: src, attrs: getAttrs(n) }, 's|' + src);
//           } else if (matches(src, DELAY_SRCS)) {
//             enqueueScript(n, src);
//           } else { return; }

//           if (n.parentNode) n.parentNode.removeChild(n);
//         });
//       });
//     });
//     mo.observe(document.documentElement, { childList: true, subtree: true });
//   } catch(e) {}

//   // ─── INIT ────────────────────────────────────────────────────────────────────
//   collectStatic();
//   purgeFonts();
//   bind();

//   // // Bot / UTM fallback — fire after load if no interaction detected
//   // var ua    = lc(navigator.userAgent);
//   // var isBot = /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|lighthouse|pagespeed|gtmetrix/.test(ua);
//   // if (/[?&](gclid|fbclid|msclkid)=/.test(location.search)) isBot = false;
//   // if (!isBot) window.addEventListener('load', function() { setTimeout(release, FALLBACK_MS); }, { once: true });

// })();

  (function () {
  var CONFIG = {
    triggerEvents: ['pointerdown', 'touchstart', 'keydown', 'mouseover', 'scroll', 'wheel'],
    fallbackDelay: 0, // 0 = disabled

    // Delay only on these pages. Empty = all pages.
    includePages: [
      /^\/$/,
      '/collections/',
      '/products/'
    ],

    // Never delay on these pages.
    excludePages: [
      // '/cart',
      // '/checkout',
      // '/checkouts',
      // '/thankyou',
      // '/thank-you'
    ],

    // Font-related files/styles to delay
    DELAY_FONTS: ['gtstandard', 'gravity-font-faces', 'shoplift'],

    debug: false
  };

  var released = false;
  var eventsBound = false;

  function log() {
    if (!CONFIG.debug) return;
    try { console.log.apply(console, ['[delay-assets]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  function lc(v) {
    return (v || '').toLowerCase();
  }

  function has(v, arr) {
    v = lc(v);
    for (var i = 0; i < arr.length; i++) {
      if (v.indexOf(lc(arr[i])) > -1) return true;
    }
    return false;
  }

  function pathMatches(rule, path) {
    if (!rule) return false;
    if (rule instanceof RegExp) return rule.test(path);
    return String(path).indexOf(String(rule)) > -1;
  }

  function matchesAny(rules, path) {
    if (!rules || !rules.length) return false;
    for (var i = 0; i < rules.length; i++) {
      if (pathMatches(rules[i], path)) return true;
    }
    return false;
  }

  function shouldDelayHere() {
    var path = location.pathname || '/';

    if (matchesAny(CONFIG.excludePages, path)) return false;
    if (!CONFIG.includePages || !CONFIG.includePages.length) return true;

    return matchesAny(CONFIG.includePages, path);
  }

  function getDelayedScripts() {
    return document.querySelectorAll('script[data-src]');
  }

  function getDelayedStyles() {
    return document.querySelectorAll('link[data-href], style[data-delay-font], link[data-delay-font]');
  }

  function isFontNode(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = el.tagName;
    if (tag !== 'LINK' && tag !== 'STYLE') return false;

    var blob =
      (el.getAttribute('href') || '') + ' ' +
      (el.getAttribute('data-href') || '') + ' ' +
      (el.textContent || '');

    return has(blob, CONFIG.DELAY_FONTS);
  }

  function markExistingFontNodes() {
    var list = document.querySelectorAll('link[href], style');
    for (var i = 0; i < list.length; i++) {
      if (isFontNode(list[i]) && !list[i].hasAttribute('data-delay-font')) {
        list[i].setAttribute('data-delay-font', 'true');
        disableStyleNode(list[i]);
      }
    }
  }

  function disableStyleNode(el) {
    if (!el) return;

    if (el.tagName === 'LINK') {
      var href = el.getAttribute('href');
      if (href && !el.getAttribute('data-href')) {
        el.setAttribute('data-href', href);
      }
      el.removeAttribute('href');
      el.setAttribute('rel', 'preload');
      el.setAttribute('as', 'style');
    } else if (el.tagName === 'STYLE') {
      el.setAttribute('type', 'text/dcss');
    }
  }

  function activateScript(oldScript, deferredMode) {
    if (!oldScript || !oldScript.parentNode) return;

    var src = oldScript.getAttribute('data-src');
    if (!src) return;

    var s = document.createElement('script');
    var attrs = oldScript.attributes;
    var i, name, value;

    for (i = 0; i < attrs.length; i++) {
      name = attrs[i].name;
      value = attrs[i].value;

      if (name === 'data-src' || name === 'type') continue;
      try { s.setAttribute(name, value); } catch (e) {}
    }

    s.src = src;
    if (deferredMode) s.defer = true;

    oldScript.parentNode.insertBefore(s, oldScript);
    oldScript.parentNode.removeChild(oldScript);

    log(deferredMode ? 'script defer:' : 'script released:', src);
  }

  function activateStyle(oldNode, immediateMode) {
    if (!oldNode || !oldNode.parentNode) return;

    if (oldNode.tagName === 'LINK') {
      var href = oldNode.getAttribute('data-href') || oldNode.getAttribute('href');
      if (!href) return;

      var l = document.createElement('link');
      var attrs = oldNode.attributes;
      var i, name, value;

      for (i = 0; i < attrs.length; i++) {
        name = attrs[i].name;
        value = attrs[i].value;

        if (
          name === 'href' ||
          name === 'data-href' ||
          name === 'rel' ||
          name === 'as' ||
          name === 'onload' ||
          name === 'media' ||
          name === 'data-delay-font'
        ) continue;

        try { l.setAttribute(name, value); } catch (e) {}
      }

      if (immediateMode) {
        l.rel = 'stylesheet';
        l.href = href;
      } else {
        l.rel = 'preload';
        l.as = 'style';
        l.href = href;
        l.onload = function () { this.onload = null; this.rel = 'stylesheet'; };
      }

      oldNode.parentNode.insertBefore(l, oldNode);
      oldNode.parentNode.removeChild(oldNode);

      log(immediateMode ? 'style immediate:' : 'style delayed:', href);
      return;
    }

    if (oldNode.tagName === 'STYLE') {
      oldNode.removeAttribute('type');
      oldNode.removeAttribute('data-delay-font');
      log('inline style released');
    }
  }

  function restoreAllDelayed() {
    var scripts = getDelayedScripts();
    var styles = getDelayedStyles();
    var i;

    for (i = 0; i < styles.length; i++) activateStyle(styles[i], false);
    for (i = 0; i < scripts.length; i++) activateScript(scripts[i], false);
  }

  function normalizeAllImmediate() {
    var scripts = getDelayedScripts();
    var styles = getDelayedStyles();
    var i;

    for (i = 0; i < styles.length; i++) activateStyle(styles[i], true);
    for (i = 0; i < scripts.length; i++) activateScript(scripts[i], true);
  }

  function release() {
    if (released) return;
    released = true;
    unbindEvents();
    restoreAllDelayed();
  }

  function bindEvents() {
    if (eventsBound) return;
    eventsBound = true;

    for (var i = 0; i < CONFIG.triggerEvents.length; i++) {
      window.addEventListener(CONFIG.triggerEvents[i], release, { passive: true, once: true });
    }
  }

  function unbindEvents() {
    if (!eventsBound) return;

    for (var i = 0; i < CONFIG.triggerEvents.length; i++) {
      window.removeEventListener(CONFIG.triggerEvents[i], release, { passive: true, once: true });
    }

    eventsBound = false;
  }

   window.__isBot = /bot|crawler|spider|crawling|googlebot|bingbot|slurp|duckduckbot|baiduspider|yandex|facebookexternalhit|twitterbot|rogerbot|linkedinbot|embedly|quora link preview|slackbot|whatsapp|telegrambot|applebot|pingdom|lighthouse|pagespeed/i.test(
    navigator.userAgent
  );
  document.documentElement.classList.add(window.__isBot ? "is-bot" : "is-human");


  function init() {
    var delayActive = shouldDelayHere();

    markExistingFontNodes();

    if (delayActive) {
      log('delay active on', location.pathname);
      bindEvents();

      if (CONFIG.fallbackDelay > 0 || !window.__isBot) {
        window.setTimeout(release, CONFIG.fallbackDelay);
      }
    } else {
      log('delay skipped on', location.pathname);
      normalizeAllImmediate();
    }
  }

  init();


 
})();
